<template>
  <v-app
    id="materialpro"
    :class="`${
      !$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'
    }`"
  >
    <router-view />
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import { applyUiTheme, getSavedUiTheme } from "@/ui-theme/themes";
export default {
  name: "App",
  components: {},
  computed: {
    ...mapState({
      autoLogout: (state) => state.user.isLogout,
    }),
  },

  watch: {
    autoLogout(curValue, oldValue) {
      if (curValue && curValue != oldValue) {
        this.$router.replace("/auth/login");
      }
    },
  },
  created() {
    // UI theme switcher: restore the last theme picked in this browser
    applyUiTheme(this.$vuetify, this.$store, getSavedUiTheme());
  },
  mounted() {},
};
</script>
<style lang="scss">
.absolute {
  position: absolute;
}
.cursor-pointer {
  cursor: pointer;
}
.font-size-12 {
  font-size: 12px;
}
.font-weight-800 {
  font-weight: 800;
}
.font-weight-bold {
  font-weight: bold;
}
</style>
